import { render, staticRenderFns } from "./DargainDetails.vue?vue&type=template&id=4679218c&scoped=true&"
import script from "./DargainDetails.vue?vue&type=script&lang=js&"
export * from "./DargainDetails.vue?vue&type=script&lang=js&"
import style0 from "./DargainDetails.vue?vue&type=style&index=0&id=4679218c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679218c",
  null
  
)

export default component.exports